"use client";

import * as Sentry from "@sentry/react";
import { type ReactNode } from "react";

// Initialize Sentry at module load time (no useEffect needed)
const dsn = import.meta.env.VITE_SENTRY_DSN;

if (dsn && import.meta.env.PROD && !Sentry.getClient()) {
    Sentry.init({
        dsn,
        tunnel: "/api/sentry-tunnel",
        environment: import.meta.env.MODE,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration({ maskAllText: false }),
        ],
        // Recommended to lower tracesSampleRate to 0.1-0.2 in production
        tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,
        // Only save replays on errors (saves free tier quota: 50/month)
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 1.0,
        beforeSend(event) {
            // Suppress "Unauthorized" errors from session expiry —
            // these fire when React Query retries protected server functions
            // after a Supabase session expires and the user is redirected to /signin.
            // Not a real error; user is handled correctly via router redirect.
            const message = event.exception?.values?.[0]?.value;
            if (message === "Unauthorized") return null;
            return event;
        },
    });
}

type Props = {
    children: ReactNode;
};

export const SentryProvider = ({ children }: Props) => {
    return <>{children}</>;
};
